import Vue from 'vue'
import vuex from 'vuex';
import App from './App.vue';
import Meta from 'vue-meta';
import createRouter from './router.js'
import { createStore } from './store'
import vueRouter from "vue-router";
import Econfig from './config.js'
// import BaiduMap from 'vue-baidu-map'
Vue.config.productionTip = false;

// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts');
// 引入柱状图
require('echarts/lib/chart/bar');
// 引入折线
require('echarts/lib/chart/line');
// 引入饼状图
require('echarts/lib/chart/pie');
// 引入提示框和标题组件
require('echarts/lib/component/legend')
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
require('echarts/lib/component/dataZoom');

Vue.prototype.$echarts = echarts;
Vue.prototype.$Econfig = Econfig.Econfig;

import Vant, { Lazyload } from 'vant'
import { webCheck } from "@/api/auction/index";
import Cookies from "js-cookie";
Vue.use(Vant)
Vue.use(Lazyload)
Vue.use(vueRouter);
Vue.use(vuex);
Vue.use(Meta);
// Vue.use(BaiduMap, {
//     // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//     ak: 'Py7N3w0gJ1F2D8O9ol1wGTnbNAIsCH7k'
//   })
export function createApp() {
    const router = createRouter()
    const store = createStore()

    const webCheckVal = async () => {
        let val = Cookies.get('_at_pt_0_');
        return new Promise((resolve) => {
            resolve({ status: 200 })
        })
        // let content = await webCheck()
        // webCheck().then((res)=>{
        //     return new Promise((resolve) => {
        //         if (val) {
        //             //    如果接口返回data.status=405 执行退出登录操作
        //             resolve(res.data)
        //         } else {
        //             resolve({status:200})
        //         }
        //     })
        // }).catch(()=>{
        //     return new Promise((resolve) => {
        //         resolve({status:200})
        //     })
        // })

    };
    router.beforeEach(async (to, from, next) => {
        // 先检查sessionStorage中是否有数据，若存在数据则加载到vuex
        //判断是否在其他设备登录
    //     if(navigator != undefined){
    //     let u = navigator.userAgent;
    //     let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //     if (isiOS && to.path !== location.pathname) {
    //         location.assign(to.fullPath)
    //     }
    // }
        let val = await webCheckVal();
        if (val && val.status == 405) {
            Vue.prototype.$dialog.confirm({
                message: val.notice,
                confirmButtonText: '重新登录',
                center: true,
                showClose: false,
                showCancelButton: false,
            }).then(() => {
                //退出
                window.location.href = '//passport.artron.net/memCenter/logout?redirect=' + encodeURIComponent(window.location.href)
            })
        } else {
            next()
        }
    })


    const app = new Vue({
        router,
        store,
        render: h => h(App)
    })
    return { app, router, store }
}

